// extracted by mini-css-extract-plugin
export default {"container":"FeedItem_container__gXI41","lastOfDay":"FeedItem_lastOfDay__IIoqO","firstOfDay":"FeedItem_firstOfDay__3-UIQ"};